import React from 'react';
import styles from './ResultAndCount.module.css';
import clsx from 'clsx'; // optional: if using className combination

const ResultAndCount = ({
  label = 'Label',
  count = 0,
  bgColor = 'var(--Primary_Color)',
  textColor,
  isCompact = false, // new prop
}) => {
  const boxStyle = {
    '--custom-color': bgColor,
  };

  const countStyle = {
    color: textColor ? `var(--${textColor})` : 'var(--Black_Color)',
  };

  return (
    <div
      className={clsx(styles.box, isCompact && styles.compactBox)}
      style={boxStyle}
    >
      <span className={styles.label}>{label}</span>
      <span
        className={clsx(styles.count, isCompact && styles.compactCount)}
        style={countStyle}
      >
        {count}
      </span>
    </div>
  );
};

export default ResultAndCount;
